import { useCallback, useState } from "react";
import {
  ReactFlow,
  useNodesState,
  useEdgesState,
  addEdge,
  ReactFlowProvider,
  Controls,
  useReactFlow,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { nodeTypes } from "./Components/nodes";
import "./App.css";
import { edgeTypes } from "./Components/customEdge";
import DomainThingmodelJson from "./data/input.json";
import Sidebar from "./Components/sidebar";
import { DnDProvider, useDnD } from "./Components/contextProvider";

// function findThingById(data: any, searchId: string): any {
  
//   if (data.id === searchId && data.type === "thing") {
//     return data;
//   }

//   // If the current item has traits, search recursively in them
//   if (data.traits && Array.isArray(data.traits)) {
//     for (const trait of data.traits) {
//       // Recursive call to search in each trait
//       const result = findThingById(trait, searchId);
//       if (result) {
//         return result; // Return the result once found
//       }
//     }
//   }

function connectNodesWithEdges(nodes: any) {
  const edges: any[] = [];

  nodes.forEach((node: any) => {
    if (node.data.IsTableConnected && Array.isArray(node.data.ref_table_id)) {
      node.data.ref_table_id.forEach((refId: string) => {
        const targetNode = nodes.find((target: any) => target.id === refId);

        if (targetNode && node.id !== targetNode.id) {
          const edge = {
            id: `${node.id}-${targetNode.id}`,
            source: node.id,
            target: targetNode.id,
            type: "customEdge",
          };
          edges.push(edge);
        }
      });
    }
  });

  return edges;
}

function processDomainThingModels(jsonData: any) {
  const domainThings = jsonData.DomainthingModels;
  const result: any[] = [];
  let positionX = 0;

  domainThings.forEach((item: any, index: number) => {
    const dynamicObject = {
      id: item.id,
      type: "thing",
      data: {
        ...item,
      },
      position: {
        x: positionX,
        y: 25,
      },
    };

    result.push(dynamicObject);
    positionX += 300;
  });

  return result;
}

function repositionNodes(
  nodes: any[],
  edges: any[],
  initialX: number = 0,
  initialY: number = 0,
  spacingX: number = 600,
  spacingY: number = 400
) {
  const visitedNodes = new Set();

  // Recursive function to position nodes and its children
  function positionNode(nodeId: string, currentX: number, currentY: number): number {
    if (visitedNodes.has(nodeId)) return currentY;

    const node = nodes.find((n: any) => n.id === nodeId);
    if (!node) return currentY;

    visitedNodes.add(nodeId);

    
    const connectedEdges = edges.filter((edge: any) => edge.source === nodeId);
    const childCount = connectedEdges.length;

    if (childCount === 0) {
      
      node.position.x = currentX;
      node.position.y = currentY;
      return currentY;
    }

   
    let nextY = currentY;
    const childPositions: number[] = [];

    connectedEdges.forEach((edge: any, index: number) => {
      nextY += spacingY;
      const childY = positionNode(edge.target, currentX + spacingX, nextY);
      childPositions.push(childY);
    });

    
    const minChildY = Math.min(...childPositions);
    const maxChildY = Math.max(...childPositions);
    const middleY = (minChildY + maxChildY) / 2;

    
    node.position.x = currentX;
    node.position.y = middleY;

    return middleY;
  }

  
  const nodesWithIncomingEdges = new Set(edges.map((edge) => edge.target));
  const rootNodes = nodes.filter(
    (node) => !nodesWithIncomingEdges.has(node.id)
  );

  
  let currentY = initialY;
  rootNodes.forEach((rootNode) => {
    positionNode(rootNode.id, initialX, currentY);
    currentY += spacingY * 2; 
  });

  return nodes;
}



function Flow() {
  const [organizedNd, setOrganizedNd] = useState<any[]>(
    processDomainThingModels(DomainThingmodelJson)
  );
 

  const organizedEdges = connectNodesWithEdges(organizedNd);
  
  const positionedNodes = repositionNodes(organizedNd, organizedEdges);
  
  const [nodes, setNodes, onNodesChange] = useNodesState(organizedNd);
  const [edges, setEdges, onEdgesChange] = useEdgesState(organizedEdges);
  const {screenToFlowPosition} = useReactFlow()
  const [dndNode,_] = useDnD();

  console.log("the dndNode is ",dndNode)

  const onConnect = useCallback(
    (params: any) =>  {
      const newEdge = {
        id: `${params.source}-${params.target}`, // Custom edge ID format
        source: params.source,
        target: params.target,
        type: 'customEdge', // Use custom edge type
      };
  
      setEdges((els) => addEdge(newEdge, els))
    },
    []
  );


  const onDragOver = useCallback((event:any) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  const onDrop = useCallback(
    (event:any) => {
      event.preventDefault();

      // check if the dropped element is valid
      if (!dndNode) {
        return;
      }
      console.log("the dndNode are",dndNode)

     
      const position = screenToFlowPosition({
        x: event.clientX,
        y: event.clientY,
      });
      const newNode = {
        id: Math.random().toString(36).substr(2, 9), // Generate random node ID
        type: "thing",
        position,
        data: dndNode,
      };
      
      setNodes((nds) => nds.concat(newNode));
    },
    [screenToFlowPosition,dndNode],
  );


  return (
    <ReactFlow
      nodeTypes={nodeTypes}
      edgeTypes={edgeTypes}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      nodes={nodes}
      edges={edges}
      fitView
      onDrop={onDrop}
      onDragOver={onDragOver}
      onConnect={onConnect}
      defaultEdgeOptions={{type: "customEdge"}}
    >
      <Controls />
    </ReactFlow>
  );
}

const FlowWrapper = () => (
  <div style={{ height: "100vh", width: "100vw" }}>
    <ReactFlowProvider>
      <DnDProvider>
    <div className="dndflow">
    <div className="reactflow-wrapper">
    <Flow />
      </div>
      <Sidebar data={DomainThingmodelJson.DomainthingModels}/>
      </div>
      
      </DnDProvider>
    </ReactFlowProvider>
  </div>
);

export default FlowWrapper;
